<template>
  <div>
    <vx-card :title="$t('Filters')" class="mb-8" collapse-action>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full">
          <label class="text-sm opacity-75">{{ $t("Search") }}</label>
          <vs-input :placeholder="$t('CodeOrName')" class="w-full mt-2" v-model="filters.keySearch" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <label class="text-sm opacity-75">{{ $t("Type") }}</label>
           <vs-select 
            class="w-full mt-2" 
            :placeholder="$t('SelectPropertyType')"
        v-model="filters.PropertyTypeId"
        >
        <vs-select-item
          v-for="(item, index) in PropertyTypes"
          :key="index"
          :value="item.ID"
          :text="currentLocale === 'ar' ? item.NameAr : item.NameEn" 
        />
      </vs-select>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <label class="text-sm opacity-75">{{ $t("City") }}</label>
         <vs-select 
            class="w-full mt-2" 
            :placeholder="$t('SelectCity')"
        v-model="filters.CityId"
        >
        <vs-select-item
          v-for="(item, index) in Cities"
          :key="index"
          :value="item.ID"
          :text="currentLocale === 'ar' ? item.NameAr : item.NameEn" 
        />
      </vs-select>
        </div>

        <div class="vx-col md:w-1/4 w-full">
          <label class="text-sm opacity-75">{{ $t("ListingStatus") }}</label>
           <vs-select 
            class="w-full mt-2" 
            :placeholder="$t('SelectPropertyType')"
            v-model="filters.StatusId"
        >
        <vs-select-item
          v-for="(item, index) in PropertyListingStatus"
          :key="index"
          :value="item.Id"
          :text="currentLocale === 'ar' ? item.NameAr : item.NameEn" 
        />
      </vs-select>
        </div>
      </div>
     <div class="vx-row mt-4">
        <div class="vx-col w-full flex justify-end">
            <vs-button color="danger" type="border" @click="resetAll">{{ $t("ResetSearch") }}</vs-button>
        </div>
        </div>
    </vx-card>

     <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        id="Scroll"
        pagination
        :max-items="itemsPerPage"
        search
        :page="currentPage"
        :data="Properties"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div class="vx-row" >
            <div class="vx-col">
              <vs-button
                type="border"
                class="ml-5"
                icon-pack="feather"
                icon="icon-plus"
                @click="AddOrEditData"
                >{{ $t("AddNewProperty") }}</vs-button
              >
            </div>
          
          </div>

          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  Properties.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : Properties.length
                }}
                of {{ Properties.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

       <template slot="thead">
          <vs-th sort-key="PropertyCode">{{ $t("Code") }}</vs-th>
          <vs-th sort-key="PropertyNameAr">{{ $t("Property") }}</vs-th>
          <vs-th>{{ $t("Type") }}</vs-th>
          <vs-th>{{ $t("Location") }}</vs-th>
          <vs-th>{{ $t("Owner") }}</vs-th>
          <vs-th>{{ $t("Value") }}</vs-th>
          <vs-th>{{ $t("Status") }}</vs-th>
          <vs-th>{{ $t("Actions") }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <tr v-for="(tr, indextr) in data" :key="indextr" @click="AddOrEditData(tr)">
              <vs-td>{{ tr.PropertyCode }}</vs-td>
              <vs-td>{{ currentLocale === 'ar' ? tr.PropertyNameAr : tr.PropertyNameEn }}</vs-td>
              <vs-td>{{ getPropertyTypeName(tr.PropertyTypeId) }}</vs-td>
              <vs-td>{{ getCityName(tr.CityId) }} / {{ getDistrictName(tr.DistrictId) }}</vs-td>
              <vs-td>{{ tr.ExternalOwnerName || 'Investor' }}</vs-td>
              <vs-td>{{ tr.EstimatedPropertyValue }}</vs-td>
              <vs-td> <vs-chip >{{ getPropertyStatusName(tr.PropertyListingStatusId) }}</vs-chip></vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary cursor-pointer" @click="AddOrEditProperty(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger cursor-pointer ml-2" @click.stop="openConfirm(tr)" />
              </vs-td>
            </tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import VxCard from "../../components/vx-card/VxCard.vue";
import { domain } from "@/gloabelConstant.js";
import vSelect from "vue-select";
import moduleProperties from "@/store/Properties/moduleProperties.js";
import modulePropertyType from "@/store/settings/PropertyType/modulePropertyType.js";
import moduleDistrict from "@/store/settings/District/moduleDistrict.js";
import moduleCity from "@/store/settings/City/moduleCity.js";

export default {
  components: {
    VxCard,
    vSelect
  },
  data() {
    return {
      baseURL: domain,
      currentPage: 1,
      userInfo: {},
      filters: {
        keySearch: "",
        PropertyTypeId: null,
        CityId: null,
        StatusId: null
      },
      itemsPerPage: 10,
      isMounted: false,
      searchTimer: null
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },

    Properties() {
      return this.$store.state.PropertiesList.Properties;
    },
    PropertyListingStatus() {
      return this.$store.state.PropertiesList.PropertyListingStatus;
    },

    PropertyTypes() {
     return this.$store.state.PropertyTypesList.items;
    },
    Districts() {
      return this.$store.state.DistrictList.Districts;
    },
    Cities() { return this.$store.state.CityList.items; },
  },
  methods: {
    debouncedSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.applyFilters();
      }, 500);
    },

   applyFilters() {
      this.$store.dispatch("PropertiesList/fetchFilteredProperties", this.filters);
},
    

    resetAll() {
      this.filters = {
        keySearch: "",
        PropertyTypeId: null,
        CityId: null,
        StatusId: null
      };

    },
    getPropertyTypeName(id) {
  
      const type = this.PropertyTypes.find(item => item.ID === id);
      if (type) {
        return this.currentLocale === 'ar' ? type.PropertyTypeNameAr : type.PropertyTypeNameEn;
      }
      return "---"; 
    },
      getPropertyStatusName(id) {
     
      const type = this.PropertyListingStatus.find(item => item.Id === id);
      if (type) {
        return this.currentLocale === 'ar' ? type.PropertyListingStatusNameAr : type.PropertyListingStatusNameEn;
      }
      return "---"; 
    },
    getCityName(id) {
      if (!this.Cities || this.Cities.length === 0) return "---";
      const city = this.Cities.find(item => item.ID === id);
      if (city) {

        return this.currentLocale === 'ar' ? city.CityNameAr : city.CityNameEn;
      }
      return "---";
    },


       getDistrictName(id) {
        
      if (!this.Districts || this.Districts.length === 0) return "---";
      const district = this.Districts.find(item => item.Id === id);
      if (district) {

        return this.currentLocale === 'ar' ? district.DistrictNameAr : district.DistrictNameEn;
      }
      return "---";
    },

     AddOrEditData(data) {
    
      if (data.Id == undefined) {
          data.Id = 0;
      }

    
      this.$router.push(`/Properties/AddOrEditProperties/${data.Id}`);
    },



    openConfirm(tr) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('ConfirmDelete'),
        text: `${this.$t('AreYouSureDelete')} ${tr.PropertyCode}`,
        accept: () => this.deleteItem(tr),
        acceptText: this.$t('Delete')
      });
    },

    deleteItem(tr) {
      this.$vs.loading();
      this.$store.dispatch("PropertiesList/removeItem", tr)
        .then(() => {
          this.$vs.loading.close();
          this.showNotify("Success", "Deleted Successfully", "success", "icon-check");
        })
        .catch(err => {
          this.$vs.loading.close();
          const errorMsg = (err.response && err.response.data && err.response.data.message) 
                           ? err.response.data.message 
                           : "Error occurred";
          this.showNotify("Error", errorMsg, "danger", "icon-alert-circle");
        });
    },

    showNotify(title, text, color, icon) {
      this.$vs.notify({
        title,
        text,
        color,
        iconPack: "feather",
        icon,
        time: 2500
      });
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    
    if (!moduleProperties.isRegistered) {
      this.$store.registerModule("PropertiesList", moduleProperties);
      moduleProperties.isRegistered = true;
    }
   
    if (!modulePropertyType.isRegistered) {
        this.$store.registerModule("PropertyTypesList", modulePropertyType);
        modulePropertyType.isRegistered = true;
        }

    if (!moduleDistrict.isRegistered) {
        this.$store.registerModule("DistrictList", moduleDistrict);
        moduleDistrict.isRegistered = true;
    }
    
    if (!moduleCity.isRegistered) {
        this.$store.registerModule("CityList", moduleCity);
        moduleCity.isRegistered = true;
    }


      this.$store.dispatch("PropertiesList/fetchDataListItems");
     this.$store.dispatch("PropertiesList/fetchPropertyListingStatus");
    this.$store.dispatch("PropertyTypesList/fetchDataListItems");
    this.$store.dispatch("DistrictList/fetchDataListItems");
    this.$store.dispatch("CityList/fetchDataListItems");


  },
  mounted() {
    this.isMounted = true;
  },
  watch: {

    'filters.keySearch'() {
      this.debouncedSearch();
    },

    filters: {
      handler() {
        this.debouncedSearch();
      },
      deep: true
    }
  },


};
</script>

<style lang="scss">

 .icon-container{
    display: flex;
  }
#data-list-list-view small {
  color: rgb(255, 115, 0);
  text-decoration: underline rgb(255, 115, 0);
}

.vxCard:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0%;
  margin-left: 10%;
  z-index: 500000;
  width: 25%;
  height: 20%;
  border-top: 3px solid rgb(255, 115, 0) !important;
  border-bottom: 0 none rgba(255, 0, 0, 0.9) !important;
  border-right: 0 none rgba(255, 0, 0, 0.9) !important;
  border-left: 0 none rgba(0, 0, 0, 0.9) !important;
}
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

    .btn{
      margin-top: 5%;
    }
  }
}
</style>
